import script from "./LiveDisplayTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./LiveDisplayTime.vue?vue&type=script&lang=ts&setup=true"

import "./LiveDisplayTime.vue?vue&type=style&index=0&id=2b836d97&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b836d97"]])

export default __exports__